import { render } from "./landingpage.vue?vue&type=template&id=2d1738ef&scoped=true"
const script = {}

import "./landingpage.vue?vue&type=style&index=0&id=2d1738ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1738ef"]])

export default __exports__